import { useMutation } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

export const useCreateSurvey = (templateUuid: string) =>
  useMutation({
    mutationFn: () => api.request(endpoints.surveys.fromTemplate(templateUuid)),
  });
